export enum Discipline {
  airPistol10m = "10m_air_pistol",
  airRifle10m = "10m_air_rifle",
}
